export default __webpack_public_path__ + "6624729a8ddfed80696658da7c6d8d34.svg";